module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/bella-mayo-b705de5c28e7f246c15946938f5ef298.jpg";